// extracted by mini-css-extract-plugin
export default {"root":"_2XHKb4a1nq8yScC9UH2057","text":"_16SoRgzDfuNu5niq-89l5Z"};